import { isNil } from "lodash-es";
import { useTranslation } from "../../../state/i18n";
import { TextAndIconButton } from "../../../components/button/Button";
import { ListItemMenu } from "../../../components/listItemMenu/ListItemMenu";
import { useTable } from "./TableProvider";

const TableFilterButton = () => {
  const { t } = useTranslation();
  const table = useTable();

  return (
    <ListItemMenu
      menu={{
        size: "lg",
        positioning: {
          placement: "bottom-start",
        },
      }}
      trigger={(triggerProps) => (
        <TextAndIconButton
          {...triggerProps}
          icon="filter"
          text={t(($) => $.TABLE_FILTER_ADD_FILTER_BUTTON_LABEL)}
          variant="secondary"
        />
      )}
      items={[
        table.filterableColumns().map((columnDef) => ({
          value: columnDef.id,
          variant: "dynamicValue",
          label: columnDef.meta.name,
          icon: !isNil(columnDef.meta.icon)
            ? { name: columnDef.meta.icon.name, class: columnDef.meta.icon.colors }
            : null,
          type: "action",
          onClick: () => table.triggerCreateFilter(columnDef.id),
        })),
      ]}
    />
  );
};

export default TableFilterButton;
